import {
  type UserFeature as _UserFeature,
  type UserWithFeatures as _UserWithFeatures,
  canAccessAlarmStatusOnly as _canAccessAlarmStatusOnly,
  canManageAlarmSettings as _canManageAlarmSettings,
  canManageDataExplorerVerifEye as _canManageDataExplorerVerifEye,
  canViewAlarmEvents as _canViewAlarmEvents,
  canViewAlarmsPage as _canViewAlarmsPage,
  canViewDataExplorerVerifEye as _canViewDataExplorerVerifEye,
  canViewExplorePage as _canViewExplorePage,
  canViewVerifeyePage as _canViewVerifeyePage,
  userHasFeature as _userHasFeature,
} from '@solinkcorp/user-features';
import { type UserSession } from './types';

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export type UserFeature = _UserFeature;

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export type UserWithFeatures = _UserWithFeatures;

export type { AspenRolloutPolicy } from '@solinkcorp/user-features';

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export const userHasFeature = _userHasFeature;

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export const canAccessAlarmStatusOnly = _canAccessAlarmStatusOnly;

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export const canManageAlarmSettings = _canManageAlarmSettings;

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export const canViewAlarmEvents = _canViewAlarmEvents;

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export const canViewAlarmsPage = _canViewAlarmsPage;

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export const canViewExplorePage = _canViewExplorePage;

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export const canViewVerifeyePage = _canViewVerifeyePage;

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export const canViewDataExplorerVerifEye = _canViewDataExplorerVerifEye;

/** @deprecated Import from '@solinkcorp/user-features' instead. */
export const canManageDataExplorerVerifEye = _canManageDataExplorerVerifEye;

/** Returns true if this user is only allowed to play back video locally. */
export function userIsLocalPlaybackOnly(user: UserSession | undefined): boolean {
  const playbackSource = user?.profile.metadata.playbackSource;
  return playbackSource && playbackSource.toLowerCase() === 'local';
}

/**
 * Returns true if this user signs in through their own identity provider. That
 * provider, not Solink, manages their password and MFA.
 */
export function userSignsInWithSso(user: UserSession | undefined): boolean {
  return Boolean(user) && user?.profile.primaryIdentityProvider !== 'auth0';
}
